/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Client } from '../../models/client';

export interface ApiKeycloakGetClientsGet$Json$Params {
  Authorization?: string;
}

export function apiKeycloakGetClientsGet$Json(http: HttpClient, rootUrl: string, params?: ApiKeycloakGetClientsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Client>>> {
  const rb = new RequestBuilder(rootUrl, apiKeycloakGetClientsGet$Json.PATH, 'get');
  if (params) {
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Client>>;
    })
  );
}

apiKeycloakGetClientsGet$Json.PATH = '/api/keycloak/GetClients';
